import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private _httpc: HttpClient) {}

  private makeUrl(url: string) {
    return environment.apiUrl + url;
  }

  public rget(url: string): Observable<any> {
    return this._httpc.get(this.makeUrl(url));
  }

  public rpost(url: string, body: any): Observable<any> {
    return this._httpc.post(this.makeUrl(url), body);
  }

  public rput(url: string, body: any): Observable<any> {
    return this._httpc.put(this.makeUrl(url), body);
  }

  public rdelete(url: string): Observable<any> {
    return this._httpc.delete(this.makeUrl(url));
  }
}
